import request from '@/utils/request'

let UnitApi = {

  /*计量单位列表*/
  list(data) {
    return request._post('/shop/plus.unit.Index/index', data);
},
/*添加计量单位*/
add(data) {
    return request._post('/shop/plus.unit.Index/add', data);
},
/*修改计量单位*/
edit(data) {
    return request._post('/shop/plus.unit.Index/edit', data);
},
/*删除计量单位*/
del(data) {
    return request._post('/shop/plus.unit.Index/del', data);
},
/*计量单位详情*/
detail(data) {
  return request._post('/shop/plus.unit.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.unit.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.unit.Setting/getSetting', data, errorback);
    },
}
export default UnitApi;



// WEBPACK FOOTER //
// ./src/api/unit.js